import {put, takeLatest, call} from 'redux-saga/effects';
import * as imageService from "../../../services/imageService";
import {
    UPDATE_IMAGE,
    UPDATE_IMAGE_SUCCESS,
    UPDATE_IMAGE_ERROR,
}
    from "../../actions/image";

function* updateImageSaga(action) {
    try {
        const data =  yield call(imageService.UpdateImage, action.payload)
        yield put({
            type: UPDATE_IMAGE_SUCCESS,
            payload: data
        });


    } catch (error) {
        yield put({
            type: UPDATE_IMAGE_ERROR,error: error.data
        });
    }
}

export function* updateImageSagaWatcher() {
    yield takeLatest(UPDATE_IMAGE, updateImageSaga);
}